import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'
import { VideoList, SelectionItemComponent } from '..'
import VideoSelectorBrowse from './VideoSelectorBrowse'

class VideoSelectorExpanded extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      search: '',
      searchContext: {
        key: 'all:video', // 'all:video', 'all:live', 'live:123', 'album:123',
        selectable: false,
        data: {},
        object: {},
      },
    }

    this.setSearchContext = this.setSearchContext.bind(this)
    this.search = this.search.bind(this)
    this.renderLoadMore = this.renderLoadMore.bind(this)
    this.renderResultsHeadline = this.renderResultsHeadline.bind(this)
  }

  setSearchContext(context) {
    this.setState({ searchContext: context })
    const { search } = this.state
    this.search(search, context)
  }

  search(s, context) {
    let newSearch = s
    let newContext = context

    if (newSearch === undefined) {
      const { search } = this.state
      newSearch = search
    }

    if (newContext === undefined) {
      const { searchContext } = this.state
      newContext = searchContext
    }

    const { performSearch } = this.props
    const data = {
      size: 32,
      ...newContext.data,
    }

    const searchMode = newContext.key === 'all:live' ? 'live' : 'video'
    performSearch(s, data, searchMode)
  }

  renderLoadMore() {
    const { results, totalResults } = this.props
    const { searchContext, search } = this.state

    if (results.length < totalResults) {
      return (
        <div className="load-more-button">
          <span
            onClick={() => {
              let newP = 2
              if (searchContext.data.p) {
                newP = searchContext.data.p + 1
              }
              const newData = { ...searchContext.data, p: newP }
              // eslint-disable-next-line
              const newContext = Object.assign({}, this.state.searchContext, {
                data: newData,
              })
              this.setState({ searchContext: newContext })
              this.search(search, newContext)
            }}
          >
            <FormattedMessage defaultMessage="Load more" />
          </span>
        </div>
      )
    }
    return null
  }

  renderResultsHeadline() {
    const { searchContext, search } = this.state
    const { toggleItem, selection, results, toggleResults } = this.props
    if (searchContext) {
      const obj = searchContext.object

      const onSelectorClick = () => {
        toggleItem(obj)
      }
      const selected = selection.findIndex((s) => s.key === obj.key) > -1
      const selectorClassName = `selector ${selected ? 'selected' : ''}`
      let { selectable } = obj
      let title = <h2>{obj.title}</h2>
      if (search !== '') {
        selectable = false
        title = (
          <h2>
            <FormattedMessage
              defaultMessage="Search for {something} in ''{somewhere}''"
              values={{
                something: <i>{search}</i>,
                somewhere: obj.title,
              }}
            />
          </h2>
        )
      }
      let toggleText = <FormattedMessage defaultMessage="Clear all" />
      if (results.findIndex((result) => result.selected_p === 0) > -1) {
        toggleText = <FormattedMessage defaultMessage="Select all" />
      }

      return (
        <div className="results-headline">
          {title}
          {selectable ? (
            <div className={selectorClassName} onClick={onSelectorClick} />
          ) : null}
          {results.length > 0 && searchContext.selectable ? (
            <span className="selection-toggle" onClick={toggleResults}>
              {toggleText}
            </span>
          ) : null}
          <div className="clear" />
        </div>
      )
    }
    return null
  }

  renderEmptyResult() {
    const { loading, results } = this.props
    const { searchContext, search } = this.state

    let emptyMessage = ''
    if (!loading && results.length === 0 && searchContext) {
      if (search === '') {
        if (searchContext.key === 'all:live') {
          emptyMessage = (
            <FormattedMessage defaultMessage="No live events to show" />
          )
        } else {
          emptyMessage = <FormattedMessage defaultMessage="No videos to show" />
        }
      } else {
        emptyMessage = (
          <FormattedMessage defaultMessage="Your search didn't return any results" />
        )
      }
      return <div className="empty-result">{emptyMessage}</div>
    }
    return null
  }

  render() {
    const { searchContext, search } = this.state
    const {
      searchIn,
      loading,
      results,
      toggleItem,
      selectionCount,
      selection,
    } = this.props
    const resultsSelectable = searchContext.selectable
    const hasAlbumSelection = selection.some((x) => x.object_type === 'album')
    return (
      <div className="video-selector video-selector-expanded">
        <div className="search-browse-container">
          <div className="search-container">
            <input
              type="text"
              value={search}
              placeholder={intl.formatMessage({
                defaultMessage: 'Search for videos',
              })}
              onChange={(e) => {
                const { value } = e.target
                const { data } = searchContext
                const newSearchContext = {
                  ...searchContext,
                  data: { ...data, p: 1 },
                }
                this.setState({
                  search: value,
                  searchContext: newSearchContext,
                })
                this.search(value, newSearchContext)
              }}
            />
          </div>
          <VideoSelectorBrowse
            context={searchContext}
            setSearchContext={this.setSearchContext}
            searchIn={searchIn}
          />
          <div className="results-container">
            <div
              className="results-inner"
              style={{ opacity: loading ? '0.5' : '1' }}
            >
              {this.renderResultsHeadline()}
              <VideoList
                items={results}
                columns={4}
                onClick={resultsSelectable ? toggleItem : () => {}}
                showAlbum={false}
                showDuration={false}
                selectable={resultsSelectable}
              />
              {this.renderLoadMore()}
              {this.renderEmptyResult()}
            </div>
            {loading ? <div className="loading-indicator" /> : null}
          </div>
        </div>
        <div className="selection-container">
          <h3>
            {hasAlbumSelection ? (
              <FormattedMessage defaultMessage="Selected category" />
            ) : (
              <FormattedMessage defaultMessage="Selection" />
            )}
            {!hasAlbumSelection && (
              <span className="selection-count">{selectionCount}</span>
            )}
          </h3>
          {selection
            .filter((obj) => obj.selected_p === 1)
            .map((obj) => {
              const id = obj.photo_id || obj.live_id || obj.object_id || obj.key
              return (
                <SelectionItemComponent
                  item={obj}
                  key={id}
                  toggleItem={toggleItem}
                />
              )
            })}
        </div>
      </div>
    )
  }
}

VideoSelectorExpanded.propTypes = {
  searchIn: PropTypes.arrayOf(
    PropTypes.oneOf(['photos', 'albums', 'live', 'site'])
  ).isRequired,
  performSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  results: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalResults: PropTypes.number.isRequired,
  toggleItem: PropTypes.func.isRequired,
  toggleResults: PropTypes.func.isRequired,
  selectionCount: PropTypes.number.isRequired,
  selection: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default VideoSelectorExpanded
